import React from 'react';
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from '../Home/HomeNav.jsx';
import FeatureIntroSection from './FeatureIntroSection.jsx';
import FeaturesGrid from './FeaturesGrid.jsx';
import HomeFooter from '../Home/HomeFooter.jsx';
const Features = () => {
  return <div className='font-figtree' data-sentry-component="Features" data-sentry-source-file="Features.jsx">
      <NextSeo {...seoFunct("FeaturesSeo")} data-sentry-element="NextSeo" data-sentry-source-file="Features.jsx" />
      <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="Features.jsx" />
      <FeatureIntroSection data-sentry-element="FeatureIntroSection" data-sentry-source-file="Features.jsx" />
      <FeaturesGrid data-sentry-element="FeaturesGrid" data-sentry-source-file="Features.jsx" />
      <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="Features.jsx" />


      <style jsx>{`
        .main-container {
          width: 100%;
        }

      `}</style>
    </div>;
};
export default withRouter(Features);